module.exports = __webpack_public_path__ + "static/media/RobinCare_logo_Favicon_white (1).6e4d26b2.png";